import { render, staticRenderFns } from "./CategoryPageContentFilter.vue?vue&type=template&id=13c53b5f&scoped=true&"
import script from "./CategoryPageContentFilter.vue?vue&type=script&lang=js&"
export * from "./CategoryPageContentFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPageContentFilter.vue?vue&type=style&index=0&id=13c53b5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c53b5f",
  null
  
)

export default component.exports